export const BADGE_CLASS = 'raffle-entry-badge';
export const BADGE_ENTRIES_CLASS = `${BADGE_CLASS}__entries`;
export const BADGE_MULTIPLIER_CLASS = `${BADGE_CLASS}__multiplier`;
export const BADGE_VISIBLE_CLASS = 'is-visible';
export const BADGE_PULSE_CLASS = 'is-pulsing';
export const BADGE_HOVER_CLASS = 'is-hover-pulsing';
export const BADGE_QTY_PULSE_CLASS = 'is-qty-pulsing';
export const DEFAULT_MULTIPLIER = 10;
export const PROCESSED_ATTR = 'data-price-text-bound';
export const HOVER_BOUND_ATTR = 'data-price-text-hover-bound';
export const PAGE_BUILDER_PRICE_SELECTOR = '[data-test-id="product-set-widget-price"]';
export const PAGE_BUILDER_BADGE_SELECTOR = `.${BADGE_CLASS}[data-badge-source="page-builder"]`;
export const SKIP_PAGES = ['cart', 'checkout', 'account'];
export const PDP_BADGE_SELECTOR = `.${BADGE_CLASS}[data-pdp-badge="true"]`;
export const PDP_QTY_CONTROL_SELECTOR = '[data-quantity-change]';
export const PDP_QTY_SELECTOR = '[data-quantity-change] input[name="qty[]"]';
export const OBSERVER_IDLE_MS = 5000;
export const LISTING_CONTAINER_SELECTOR = '#product-listing-container';
export const FACETED_PAGE_CLASSES = ['category', 'search', 'brand'];

export const PRICE_SELECTORS = [
    '.card [data-test-info-type="price"]',
    '.listItem-price',
    '[data-test-id="product-set-widget-price"]',
];

export const PRODUCT_NODE_SELECTORS = [
    '.card',
    '.listItem',
    '.productCarousel-slide',
    '[id^="sd-product-set"]',
    '[data-test-id="product-set-widget"]',
];

export const PRICE_SELECTOR = PRICE_SELECTORS.join(', ');
export const PRODUCT_NODE_SELECTOR = PRODUCT_NODE_SELECTORS.join(', ');
